import React, { Component } from 'react';
import {Subtopic, TextHolder, Footer, Button} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';



export class ChapterHundredTwentyTwo extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">


        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {""}
        </Subtopic>



                  <TextHolder textBigTitle="Co-working spaces"/>
                <TextHolder textTitle="Indonesia"/>


                  <div className="block-outer block-outer-tableholder">
                      <div className="block-inner block-inner-tableholder">
                          <table id="t01">
                          <tbody>


                          <tr>
                            <td><a href="http://bandungdigitalvalley.com/">Bandung Digital Valley</a></td>
                          </tr>
                          <tr>
                            <td><a href="http://www.cre8.id/contact-cre8.php">Cre8</a></td>
                          </tr>
                          <tr>
                            <td><a href="https://www.epicaoffices.com/">Epica Lifestyle Offices</a></td>
                          </tr>
                          <tr>
                            <td><a href="https://evhive.co/">EV Hive</a></td>
                          </tr>
                          <tr>
                            <td><a href="https://www.freewarespaces.com/">Freeware Spaces</a></td>
                          </tr>
                          <tr>
                            <td><a href="https://go-work.com/">GoWork</a></td>
                          </tr>
                          <tr>
                            <td><a href="https://hubud.org/">Hubud</a></td>
                          </tr>
                          <tr>
                            <td><a href="http://www.kedasi.co.id/">kedasi</a></td>
                          </tr>
                          <tr>
                            <td><a href="https://www.outpost-asia.com/">Outpost Bali</a></td>
                          </tr>
                          <tr>
                            <td><a href="https://www.wework.com/l/indonesia">wework</a></td>
                          </tr>



                                </tbody>
                                </table>
                                <div className="highcharts-notes">
                                  <p> </p>
                                  <p> </p>
                                </div>
                            </div>
                        </div>

                        <TextHolder textTitle="Malaysia"/>


                          <div className="block-outer block-outer-tableholder">
                              <div className="block-inner block-inner-tableholder">
                                  <table id="t01">
                                  <tbody>



                                  <tr>
                                    <td><a href="https://www.facebook.com/2ndSpaceSetiaAlam/">2nd Space</a></td>
                                  </tr>
                                  <tr>
                                    <td><a href="https://www.facebook.com/aspaceto/">A space to ____.</a></td>
                                  </tr>
                                  <tr>
                                    <td><a href="http://co3.co/">CO3 Social Office</a></td>
                                  </tr>
                                  <tr>
                                    <td><a href="https://collab-coworking-space.business.site/">Collab Coworking Space</a></td>
                                  </tr>
                                  <tr>
                                    <td><a href="https://colony.work/">ColonySpace</a></td>
                                  </tr>
                                  <tr>
                                    <td><a href="http://www.commonroom.com.my/">Common Room Bangi</a></td>
                                  </tr>
                                  <tr>
                                    <td><a href="https://www.commonground.work/">CommonGround</a></td>
                                  </tr>
                                  <tr>
                                    <td><a href="https://dojokl.com/">DojoKL</a></td>
                                  </tr>
                                  <tr>
                                    <td><a href="https://jointhe.co/">The Co</a></td>
                                  </tr>
                                  <tr>
                                    <td><a href="https://uppercase.asia/">Uppercase</a></td>
                                  </tr>
                                  <tr>
                                    <td><a href="http://www.whitespaceinternational.com/">Whitespace International</a></td>
                                  </tr>
                                  <tr>
                                    <td><a href="https://worq.space/">WORQ</a></td>
                                  </tr>


                                        </tbody>
                                        </table>
                                        <div className="highcharts-notes">
                                          <p> </p>
                                          <p> </p>
                                        </div>
                                    </div>
                                </div>


                        <TextHolder textTitle="Philippines"/>


                          <div className="block-outer block-outer-tableholder">
                              <div className="block-inner block-inner-tableholder">
                                  <table id="t01">
                                  <tbody>



                                  <tr>
                                    <td><a href="http://47east.strikingly.com/">47 East</a></td>
                                  </tr>
                                  <tr>
                                    <td><a href="https://www.acleanplace.ph/">A Clean and Well-Lighted Place for Work</a></td>
                                  </tr>
                                  <tr>
                                    <td><a href="https://aspacemanila.com/">A SPACE</a></td>
                                  </tr>
                                  <tr>
                                    <td><a href="https://arendo.com.ph/">Arendo Coworking</a></td>
                                  </tr>
                                  <tr>
                                    <td><a href="https://www.loft.ph/">LOFT Coworking</a></td>
                                  </tr>
                                  <tr>
                                    <td><a href="http://www.qbo.com.ph/">QBO</a></td>
                                  </tr>
                                    </tbody>
                                    </table>
                                        <div className="highcharts-notes">
                                          <p> </p>
                                          <p> </p>
                                        </div>
                                    </div>
                                </div>

                                <TextHolder textTitle="Singapore"/>


                                  <div className="block-outer block-outer-tableholder">
                                      <div className="block-inner block-inner-tableholder">
                                          <table id="t01">
                                          <tbody>



                                          <tr>
                                            <td><a href="https://www.collective.works/">Collective Works</a></td>
                                          </tr>
                                          <tr>
                                            <td><a href="https://www.collision8.com">Collision8</a></td>
                                          </tr>
                                          <tr>
                                            <td><a href="https://www.found.us">Found.</a></td>
                                          </tr>
                                          <tr>
                                            <td><a href="http://justcoglobal.com/">Just Co.</a></td>
                                          </tr>
                                          <tr>
                                            <td><a href="http://jointhe.co/">The Co.</a></td>
                                          </tr>
                                          <tr>
                                            <td><a href="http://thegreatroomoffices.com/">The Great Room</a></td>
                                          </tr>
                                          <tr>
                                            <td><a href="http://thehive.sg/">The Hive</a></td>
                                          </tr>
                                          <tr>
                                            <td><a href="http://trehauscowork.com/">Trehaus</a></td>
                                          </tr>
                                          <tr>
                                            <td><a href="http://wework.com/l/singapore">We Work</a></td>
                                          </tr>

                                                  </tbody>
                                                </table>
                                                <div className="highcharts-notes">
                                                  <p> </p>
                                                  <p> </p>
                                                </div>
                                            </div>
                                        </div>

                              <TextHolder textTitle="Thailand"/>


                                <div className="block-outer block-outer-tableholder">
                                    <div className="block-inner block-inner-tableholder">
                                        <table id="t01">
                                        <tbody>



                                        <tr>
                                          <td><a href="http://www.hubbathailand.com">Hubba</a></td>
                                        </tr>
                                        <tr>
                                          <td><a href="http://kohub.org">Kohob</a></td>
                                        </tr>
                                        <tr>
                                          <td><a href="https://www.launchpad.co.th">Launchpad</a></td>
                                        </tr>
                                        <tr>
                                          <td><a href="http://www.officefirst.net/mainpage/home.php">Officefirst</a></td>
                                        </tr>
                                        <tr>
                                          <td><a href="http://silomspace.com">Silomspace</a></td>
                                        </tr>
                                        <tr>
                                          <td><a href="http://wolfcoworking.com/#billboard">Wolfcoworking</a></td>
                                        </tr>



                                              </tbody>
                                              </table>
                                              <div className="highcharts-notes">
                                                <p> </p>
                                                <p> </p>
                                              </div>
                                          </div>
                                      </div>

                              <TextHolder textTitle="Vietnam"/>


                                <div className="block-outer block-outer-tableholder">
                                    <div className="block-inner block-inner-tableholder">
                                        <table id="t01">
                                        <tbody>



                                        <tr>
                                          <td><a href="https://www.circo.co">Circo</a></td>
                                        </tr>
                                        <tr>
                                          <td><a href="https://www.co-spacevn.com">Co-Space</a></td>
                                        </tr>
                                        <tr>
                                          <td><a href="https://dreamplex.co">Dreanplex</a></td>
                                        </tr>
                                        <tr>
                                          <td><a href="http://ka-koncept.com/en/">Ka Koncept</a></td>
                                        </tr>
                                        <tr>
                                          <td><a href="http://www.neighborhub.ukf.vn/US">Neighborhub</a></td>
                                        </tr>

                                              </tbody>
                                              </table>
                                              <div className="highcharts-notes">
                                                <p> </p>
                                                <p> </p>
                                              </div>
                                          </div>
                                      </div>



          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/122.js